import React from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';
import { dossierValidatorsSelector, FormalityValidator } from '@europrocurement/l2d-domain';
import { useSelector } from 'react-redux';
import { FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import { useForm } from 'react-hook-form';

type ShowValidatorModalProps = {
    formalityValidator: FormalityValidator;
    onSubmit: (validator: FormalityValidator) => void;
    onCancel: () => void;
};

type ValidatorFormData = {
    default: boolean;
    forms: boolean;
    documents: boolean;
};

const ShowValidatorModal: React.FunctionComponent<ShowValidatorModalProps> = function (props) {
    const { formalityValidator, onSubmit, onCancel } = props;
    const { palette } = useTheme();
    const dataSource = useSelector(dossierValidatorsSelector);
    const validator = dataSource.data.find(
        (v) => (v.id as unknown as number) === formalityValidator.validator,
    );

    const formStructure: FormStructure[] = [
        {
            type: 'boolean',
            name: 'default',
            inputlabel: 'Valideur par défaut',
        },
        {
            type: 'boolean',
            name: 'forms',
            inputlabel: 'Communiquer les informations des formulaires',
        },
        {
            type: 'boolean',
            name: 'documents',
            inputlabel: 'Communiquer les documents',
        },
    ];

    const formContext = useForm<ValidatorFormData>({
        mode: 'onTouched',
        defaultValues: {
            default: formalityValidator.default,
            forms: formalityValidator.forms,
            documents: formalityValidator.documents,
        },
    });

    const handleSubmit = (data: ValidatorFormData) => {
        onSubmit({
            ...formalityValidator,
            ...data,
        });
    };

    const formProps = {
        formContext,
        formObject: {},
        onSubmit: handleSubmit,
        submitButton: {
            displayed: false,
        },
    };

    return (
        <Box sx={{ width: '450px', display: 'flex', flexDirection: 'column', gap: '16px 0' }}>
            <Typography variant="l2dh6">Valideur {validator?.label}</Typography>
            <FlexyForm
                formStructure={formStructure}
                {...formProps}
            />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                    variant="text"
                    onClick={onCancel}
                    sx={{
                        color: palette.primary.main,
                        ':hover': {
                            color: palette.primary.light,
                        },
                    }}
                >
                    Annuler
                </Button>
                <Button
                    variant="contained"
                    onClick={formContext.handleSubmit(handleSubmit)}
                    sx={{
                        padding: '16px 24px',
                        backgroundColor: palette.primary.main,
                        color: palette.getContrastText(palette.primary.main),
                        ':hover': {
                            backgroundColor: palette.primary.light,
                            color: palette.getContrastText(palette.primary.light),
                        },
                    }}
                >
                    Confirmer
                </Button>
            </Box>
        </Box>
    );
};

export default ShowValidatorModal;
